export type RegisterPayload = {
  name: string;
  surname: string;
  phone: string;
  email: string;
  companyName: string;
  vertical: "restaurant" | "hospitality";
};

export type RegisterResponse = {
  checkoutUrl: string;
};

export async function register(payload: RegisterPayload): Promise<RegisterResponse> {
  const res = await fetch("/api/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message ?? "Registrazione fallita");
  }

  return res.json();
}
